// extracted by mini-css-extract-plugin
export default {"title":"baa-z","warning":"caa-z","sizeOptionsLegendText":"daa-z"};